import { RouteConfig } from 'vue-router';
import {metaRequireAuth} from '@/router/meta-constants';

const authenticatedRoutes: Array<RouteConfig> = [
    {
        path: '/account',
        name: 'Account',
        meta: metaRequireAuth,
        component: () => import(/* webpackChunkName: "authenticate" */ '@/views/web/account/index.vue')
    }
];

export default authenticatedRoutes;
